// extracted by mini-css-extract-plugin
export default {"label_div":"cropImageDialogPanel_label_div__ivUcX","box_settings":"cropImageDialogPanel_box_settings__bIRI+"};